import React, { Component } from "react";
import { Link } from "react-router-dom";
import { SectionHeader, ContainerWrapper, SectionWrapper, FlexCenter } from "../Utils";
import "./index.css";


export default class Offers extends Component {

 
  render() {
  const themeOne = [
    {
      name: 'Examine',
      url: '/gers-model',
      external: true
    },
    {
      name: 'Explore',
      url: 'https://jtool.cugcr.ca/',
      external: true
    },
    {
      name: 'GERS principles project',
      url: '/principles-project',
      external: true
    }
  ];

  return (                  
    <SectionWrapper mt="1rem" mb="1rem" pb="3rem">    
      <ContainerWrapper className="text-center">
        <SectionHeader mt="0.25rem" mb="0.25rem" pt="1rem" pb="1rem">GERS model</SectionHeader>
        <FlexCenter className="offers__grid mx-5">
          {
            themeOne && themeOne.map((theme, index) => (
              theme.external ? (
                <a href={theme.url} key={theme.name.replace(/\s/g, '')} onClick={(e) => { if (!window.confirm(`You are about to open ${theme.name} in a new tab`)) { e.preventDefault(); return false; }} } className="offers__grid-item d-flex flex--center" data-theme={index} target="_blank" rel="noopener noreferrer">
                  <p>{theme.name}</p>
                </a>
              ) : 
              (
                <Link to={theme.url} key={theme.name.replace(/\s/g, '')} className="offers__grid-item d-flex flex--center" data-theme={index}>
                        <p>{theme.name}</p>
                </Link>
              )
              ))
          }
        </FlexCenter>  
      </ContainerWrapper>
    </SectionWrapper>
  );
  }
}


   



// WEBPACK FOOTER //
// ./src/Components/Offers/index.js